import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { LogOut, Users, Settings, FileText } from 'lucide-react';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    {
      title: 'Лиды',
      description: 'Просмотр всех заявок с форм',
      icon: <Users className="w-8 h-8" />,
      color: 'bg-blue-100 text-blue-600',
      path: '/admin/leads'
    },
    {
      title: 'Контент',
      description: 'Редактирование текстов и переводов',
      icon: <FileText className="w-8 h-8" />,
      color: 'bg-green-100 text-green-600',
      path: '/admin/content'
    },
    {
      title: 'Настройки',
      description: 'Контакты, цены, изображения',
      icon: <Settings className="w-8 h-8" />,
      color: 'bg-purple-100 text-purple-600',
      path: '/admin/settings'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0052CC]">Админ-панель</h1>
            <p className="text-sm text-gray-600">Los Jardines</p>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600">{user?.username}</span>
            <Button
              onClick={handleLogout}
              variant="outline"
              className="flex items-center gap-2"
            >
              <LogOut className="w-4 h-4" />
              Выйти
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Добро пожаловать!</h2>
        
        <div className="grid md:grid-cols-3 gap-6">
          {menuItems.map((item, index) => (
            <Card
              key={index}
              className="hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => navigate(item.path)}
            >
              <CardContent className="p-6">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full mb-4 ${item.color}`}>
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Quick Stats */}
        <div className="mt-8 bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Быстрая статистика</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-[#0052CC]">35%</p>
              <p className="text-sm text-gray-600">Продано квартир</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-[#FFC400]">€297K</p>
              <p className="text-sm text-gray-600">Начальная цена</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-green-600">-</p>
              <p className="text-sm text-gray-600">Новых лидов</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
